<template>
    <div class="">
        <a data-toggle="collapse" href="#collapseOpenTasks" aria-expanded="true"  class="list relative text-decoration-none text-white">
            <h4 class="font-weight-bold badge-dark p-2 pl-4 rounded-pill">Open Tasks</h4>
        </a>
        <div class="col-12 px-4 mb-4 mx-auto collapse show" id="collapseOpenTasks">
            <div class="" v-for="task in this.tasksOpen">
                <div class="card justify-content-around my-2 p-3 pb-1 rounded row mb-2" style="border-radius: 10px !important" v-if="task.active">
                    <div class="border-bottom col-12 pb-1">
                        <p class="lead mb-1 font-weight-bold" style="line-height: 1.3rem">{{task.title}}</p>
                    </div>
                    <div class="d-flex flex-lg-row pt-2">
                        <div class="col-7">
                            <p class="mb-1 font-italic" v-html="task.description"></p>
                            <p class="mb-1 font-weight-bold">Complete By {{task.deadline | formatDate}}</p>
                        </div>
                        <div class="col-5 d-flex" style="justify-content: end; align-items: start;">
                            <button class="border border-dark btn mt-1 btn-darkgray px-4 py-2 w-auto" @click="handleTask($event)" :id="task.id" :description="task.description" :type="task.type" :relation="task.relation_id" :link="task.link" :uploaded_file="task.uploaded_file" :title="task.title">Complete Task</button>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
        <!----COMPLETED TASKS ---->
        <a data-toggle="collapse" href="#collapseClosedTasks" aria-expanded="false" class="list relative text-decoration-none text-white">
            <h4 class="font-weight-bold badge-secondary p-2 pl-4 rounded-pill">Completed Tasks</h4>
        </a>
        <div class="col-12 mb-4 collapse" id="collapseClosedTasks">
            <div class="card bg-dark text-white d-flex flex-lg-row justify-content-around my-2 p-3 pb-1 rounded row" style="border-radius: 10px !important;" v-for="task in this.tasksComplete">
                <div class="col-7">
                    <p class="lead mb-1 font-weight-bold" style="line-height: 1.3rem">{{task.title}}</p>
                     <p class="mb-1 font-italic" v-html="task.description"></p>
                     <p class="mb-1 font-italic">Completed {{task.pivot.updated_at | formatDate}}</p>
                </div>
                <div class="col-5 d-flex" style="justify-content: end; align-items: center;">
                    <button v-if="
                        task.id == 5
                        || task.type=='lead-gen'
                        || task.type=='emcee'
                        || (60 < task.id && task.id < 131)
                        //|| task.type=='upload'
                        || (task.type=='breakout' && task.link == 'submit-breakout-details')
                        || task.type=='upload-video'
                        || task.type=='upload-email'
                        || task.type=='email-date'
                        || task.type=='push-notification'
                        || (task.type=='booth' && task.id !== 40)
                        || task.type=='attendee'
                        || (task.type=='sponsor_level' && task.link == 'oh-choose-partner-logo')
                        || (task.type=='sponsor_level' && task.link == 'tx-choose-partner-logo')
                        || (task.type=='sponsor_level' && task.link == 'co-choose-partner-logo')
                        " class="btn btn-sm" type="" :link="task.link" :id="task.id" @click="handleTaskItem($event)">Review</button>
                </div>
            </div>
            <div class="card bg-dark text-white d-flex flex-lg-row justify-content-around my-2 p-3 pb-1 rounded row" style="border-radius: 10px !important;">
                <div class="col-7">
                    <p class="lead mb-0 font-weight-bold" style="line-height: 1.3rem">Company Information Added.</p>
                    <p class="mb-1 font-italic">Completed {{companyDate | formatDate}}</p>
                    <!-- <p class="mb-1">Register your company</p> -->
                </div>
                <div class="col-5 d-flex" style="justify-content: end; align-items: center;"></div>
            </div>
            <div class="card  bg-dark text-white d-flex flex-lg-row justify-content-around my-2 p-3 pb-1 rounded row" style="border-radius: 10px !important;">
                <div class="col-7">
                    <p class="lead mb-1 font-weight-bold" style="line-height: 1.3rem">Sponsorship Level Chosen.</p>
                    <p class="mb-1 font-italic">Completed {{sponsorshipDate | formatDate}}</p>
                    <!-- <p class="mb-1">Choose your sponsorship level.</p> -->
                </div>
                <div class="col-5 d-flex" style="justify-content: end; align-items: center;"></div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
export default {
        props: {
            owesMoney:Boolean,
            sponsorship: Number,
            companyDate: String,
            company: Number,
            sponsorshipDate: String,
        },
        mounted() {
            console.log(this.owesMoney)
            this.$store.commit('SET_COMPANY', this.company)
            this.$store.commit('SET_SPONSORSHIP', this.sponsorship)
            // this.$nextTick(() => {
            // })
            this.$store.dispatch('getTasks')
        },
        computed: {
            ...mapState(['tasks', 'availablePasses']),
            tasksOpen() {
                this.tasks.tasksOpen = this.owesMoney ? this.tasks.tasksOpen : this.tasks.tasksOpen.filter(this.hidePaymentTask)
                return this.tasks.tasksOpen
            },
            tasksComplete() {
                return this.tasks.tasksComplete
            },

        },
    methods: {
        handleTask(event) {
            if (60 <= event.target.id && event.target.id <= 131) {
                this.$store.dispatch('goToPasses')
            } else {
                this.$store.commit('HANDLE_TASK', event)
            }
        },
        handleTaskItem(event) {
            if (60 <= event.target.id && event.target.id <= 131) {
                this.$store.dispatch('goToPasses')
            } else if(event.target.id =='5') {
                this.$store.dispatch('goToTaskItem', {'id':event.target.id, 'link':event.target.link})
            }else {
                this.$store.dispatch('goToTaskItemEdit', {'id':event.target.id})
            }
        },
        hidePaymentTask(task) {
            return task.id !== 20;
        }
    },
}
</script>
